'use client';

import { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import RecentReviews from './RecentReviews';
import GenreCards from './GenreCards';
import ReadingStats from './ReadingStats';

export default function DashboardInteractive() {
  const [isHydrated, setIsHydrated] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleSearch = (query: string) => {
    if (!isHydrated) return;
    setSearchQuery(query);
    console.log('Searching for:', query);
    // In production, this would trigger actual search functionality
  };

  const handleGenreSelect = (genre: string) => {
    if (!isHydrated) return;
    console.log('Selected genre:', genre);
    // In production, this would navigate to filtered book list
  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-12 h-12 rounded-full border-4 border-primary/20 border-t-primary animate-spin" />
      </div>
    );
  }

  return (
    <>
      <HeroSection onSearch={handleSearch} />
      <RecentReviews />
      <GenreCards onGenreSelect={handleGenreSelect} />
      <ReadingStats />
    </>
  );
}